import React from "react";
import styles from "./main_select.module.css";
import { openModal } from "../../../../components/ajonjolib/toasts/toast/toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faBolt, faTemperatureHalf, faFileLines, faNetworkWired, faUpload, faClockRotateLeft, faCarBattery, faSliders } from "@fortawesome/free-solid-svg-icons";
import { canOperate, isAdmin } from "../../../../utils/roles";
import { useTranslation } from 'react-i18next';

function PduiStatus({ data, pduiData, recentEmergency }) {
  if (!data?.status) return null;
  return (
    <div className={styles.pduiPorts}>
      <div className={"d-flex align-items-center justify-content-center"}>
        <div style={{ position: "relative", height: `${Math.round((pduiData?.model["image_height"] ?? 100) * 0.75)}px`, margin: "8px 0px" }}>
          <img
            alt={"pdui"}
            src={`/pduis/${pduiData?.model?.image_name}/pdui_ports_ign.png`}
            width={"auto"}
            height={`${Math.round((pduiData?.model["image_height"] ?? 100) * 0.75)}px`}
          />
          {Array.from(
            { length: pduiData?.model.port_count },
            (_, index) => index + 1,
          ).map((port, index) => {
            return (
              <div
                key={index}
                className={styles.port}
                style={{
                  display: data["status"][port - 1] ? "block" : "none",
                  top: `${pduiData?.model["port_y_values"][port - 1]}%`,
                  left: `${pduiData?.model["port_x_values"][port - 1]}%`,
                }}
              />
            );
          })}
          <div
            className={styles.ign}
            style={{
              display: data["ignition_status"] ? "flex" : "none",
              top: `${pduiData?.model[`ign_y`] - 1.8}%`,
              left: `${pduiData?.model[`ign_x`] + 0.15}%`,
              userSelect: "none",
            }}
          >
            <div>IGN</div>
          </div>
        </div>
        {recentEmergency && <div className={styles.emergencyStop}></div>}
      </div>
    </div>
  );
}

function GeneralSettings({ data, t }) {
  return (
    <div>
      <div
        className={"d-flex align-items-center justify-content-center"}
        style={{
          borderRadius: "9px",
          backgroundColor: "#6A86C8",
          color: "#FFF",
          minWidth: "113px",
          height: "42px",
          flex: "0 1 auto",
          padding: "0 15px",
          cursor: "pointer",
        }}
        onClick={() => {
          openModal("output_states", data);
        }}
      >
        <svg
          width="23"
          height="23"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24.7931 20.2121C25.0303 19.7925 25.2441 19.3539 25.4324 18.8999C25.6368 18.4076 25.8102 17.8959 25.9486 17.3711C25.9747 17.2368 26.0784 17.1245 26.2202 17.0939L27.9803 16.712C28.1574 16.6736 28.3074 16.5792 28.4107 16.4505C28.514 16.3222 28.5748 16.1559 28.5748 15.9742V12.6006C28.5748 12.4186 28.514 12.2526 28.4107 12.1239C28.3074 11.9956 28.1574 11.9009 27.9803 11.8628L26.2202 11.4809C26.0945 11.4525 25.9885 11.3574 25.9542 11.2243C25.8151 10.6943 25.6402 10.1762 25.432 9.67451C25.2247 9.17172 24.9826 8.6861 24.7122 8.22173C24.6376 8.10909 24.6312 7.95765 24.7088 7.83643L25.6849 6.32025C25.7823 6.16807 25.8211 5.99537 25.8035 5.82977C25.7864 5.66566 25.7114 5.50527 25.5835 5.37734L23.1975 2.99172C23.0692 2.86379 22.9088 2.78882 22.7451 2.77129C22.5794 2.75375 22.4056 2.79292 22.2542 2.89027L20.738 3.866C20.6298 3.93425 20.4881 3.94171 20.3703 3.87234C19.9059 3.60081 19.4195 3.35762 18.9085 3.14576C18.4057 2.93801 17.8944 2.7642 17.3707 2.62619C17.2364 2.59971 17.1238 2.49639 17.0936 2.35466L16.712 0.594539C16.6736 0.417371 16.5792 0.267804 16.4505 0.164487C16.3222 0.0607967 16.1559 0 15.9742 0H12.6006C12.4186 0 12.2526 0.0607967 12.1239 0.164487C11.9956 0.267804 11.9009 0.417371 11.8628 0.594539L11.4812 2.35466C11.4529 2.48036 11.3578 2.58591 11.225 2.6206C10.6943 2.75935 10.1754 2.93465 9.67413 3.14241C9.17098 3.35053 8.68572 3.59185 8.2221 3.86264C8.10909 3.93724 7.95765 3.94321 7.83643 3.866L6.32025 2.89027C6.17105 2.79404 5.99985 2.75487 5.83313 2.77091C5.66603 2.78882 5.50527 2.86379 5.37734 2.99172L2.99172 5.37734C2.86379 5.50527 2.78882 5.66603 2.77129 5.82977C2.75375 5.99537 2.79292 6.16919 2.89027 6.32025L3.866 7.83643C3.93425 7.94497 3.94171 8.08671 3.87234 8.20457C3.60081 8.66894 3.35762 9.15568 3.14576 9.6663C2.93764 10.1695 2.7642 10.6804 2.62619 11.2037C2.59971 11.3377 2.49639 11.4503 2.35466 11.4809L0.594539 11.8628C0.417371 11.9009 0.267804 11.9956 0.164487 12.1239C0.0607967 12.2526 0 12.4186 0 12.6006V15.9742C0 16.1559 0.0607967 16.3222 0.164487 16.4505C0.267804 16.5792 0.417371 16.6736 0.594539 16.712L2.35466 17.0939C2.48036 17.1223 2.58591 17.2174 2.6206 17.3502C2.75823 17.8765 2.9313 18.3897 3.1383 18.8914C3.35202 19.405 3.59335 19.8906 3.86264 20.3531C3.93724 20.4657 3.94321 20.6168 3.866 20.738L2.89027 22.2542C2.79404 22.4038 2.75487 22.575 2.77091 22.7417C2.78882 22.9088 2.86379 23.0692 2.99172 23.1975L5.37734 25.5835C5.50378 25.7099 5.66118 25.7845 5.82604 25.8032C5.99537 25.8211 6.16807 25.7823 6.32025 25.6849L7.83643 24.7088C7.94497 24.6406 8.08671 24.6331 8.20457 24.7021C8.66856 24.9736 9.15382 25.2161 9.66481 25.4283C10.1683 25.6372 10.6801 25.8106 11.2037 25.9486C11.3377 25.9747 11.4507 26.0784 11.4812 26.2202L11.8628 27.9803C11.9009 28.1574 11.9956 28.3074 12.1239 28.4107C12.2526 28.514 12.4186 28.5748 12.6006 28.5748H15.9742C16.1559 28.5748 16.3222 28.514 16.4505 28.4107C16.5792 28.3074 16.6736 28.1574 16.712 27.9803L17.0936 26.2202C17.1219 26.0945 17.217 25.9885 17.3498 25.9542C17.8809 25.8151 18.3994 25.6402 18.9014 25.432C19.3546 25.2444 19.7929 25.0303 20.2121 24.7931L17.9443 22.5283C17.3782 22.7797 16.7799 22.9752 16.1566 23.1065C15.552 23.234 14.925 23.3019 14.2876 23.3019C11.7979 23.3019 9.54434 22.293 7.91327 20.6619C6.2822 19.0309 5.27327 16.7773 5.27327 14.2876C5.27327 11.7979 6.2822 9.54434 7.91327 7.91327C9.54434 6.2822 11.7979 5.27327 14.2876 5.27327C16.7773 5.27327 19.0309 6.2822 20.6619 7.91327C22.293 9.54434 23.3019 11.7979 23.3019 14.2876C23.3019 14.9336 23.2333 15.5669 23.1024 16.1779C22.9711 16.7922 22.7768 17.3841 22.5269 17.9458L24.7931 20.2121ZM29.2615 25.679L19.8917 16.3096C19.8041 16.22 19.7656 16.0873 19.8037 15.9593C20.1058 14.9579 20.13 13.8889 19.8764 12.8781C19.6317 11.9027 19.1267 10.977 18.3621 10.2124C17.5572 9.40745 16.5744 8.89049 15.5446 8.66148C14.6621 8.46566 13.7408 8.47946 12.862 8.70288L15.0783 10.9173C15.6497 11.4887 15.9362 12.2436 15.9362 12.9974C15.9362 13.7397 15.6576 14.4827 15.0895 15.0649C14.5065 15.6494 13.7516 15.9358 12.9978 15.9358C12.2541 15.9358 11.5103 15.6561 10.9404 15.0985L8.70251 12.8624C8.47909 13.7408 8.46529 14.6613 8.66111 15.5434C8.89012 16.5747 9.40745 17.5576 10.2116 18.3625C10.9755 19.1263 11.9012 19.6314 12.8781 19.876C13.8814 20.1278 14.9426 20.1058 15.9377 19.8097C16.0626 19.7641 16.2088 19.791 16.3096 19.8917L25.679 29.2615C26.1713 29.7538 26.821 30 27.47 30C28.1198 30 28.7691 29.7538 29.2615 29.2615C29.7538 28.7691 30 28.1198 30 27.47C30 26.821 29.7538 26.1713 29.2615 25.679Z"
            fill="white"
          />
        </svg>
        <div className={"ps-2"} style={{ fontSize: "15px" }}>
          {t('detail.nav.general')}
        </div>
      </div>
    </div>
  );
}

function ResetAll({ pduiId, t }) {
  const onClick = async () => {
    openModal("reset_all", { pduiId });
  };

  return (
    <div>
      <div
        className={"d-flex align-items-center justify-content-center"}
        style={{
          borderRadius: "9px",
          backgroundColor: "#e69720",
          color: "#FFF",
          minWidth: "113px",
          height: "42px",
          flex: "0 1 auto",
          padding: "0 15px",
          cursor: "pointer",
        }}
        onClick={onClick}
      >
        <svg
          className="w-6 h-6 text-gray-800 dark:text-white"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="23"
          height="23"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 8v4l3 3M3.22302 14C4.13247 18.008 7.71683 21 12 21c4.9706 0 9-4.0294 9-9 0-4.97056-4.0294-9-9-9-3.72916 0-6.92858 2.26806-8.29409 5.5M7 9H3V5"
          />
        </svg>

        <div className={"ps-2"} style={{ fontSize: "15px" }}>
          {t('detail.nav.resetAll')}
        </div>
      </div>
    </div>
  );
}

function RestartPDUI({ pduiId, t }) {
  const onClick = async () => {
    openModal("restart", { pduiId });
  };

  return (
    <div>
      <div
        className={"d-flex align-items-center justify-content-center"}
        style={{
          borderRadius: "9px",
          backgroundColor: "#d53c3c",
          color: "#FFF",
          minWidth: "113px",
          height: "42px",
          flex: "0 1 auto",
          padding: "0 15px",
          cursor: "pointer",
        }}
        onClick={onClick}
      >
        <svg
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="23"
          height="23"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M17.651 7.65a7.131 7.131 0 0 0-12.68 3.15M18.001 4v4h-4m-7.652 8.35a7.13 7.13 0 0 0 12.68-3.15M6 20v-4h4"
          />
        </svg>

        <div className={"ps-2"} style={{ fontSize: "15px" }}>
          {t('detail.nav.restartPdui')}
        </div>
      </div>
    </div>
  );
}

export default function MainSelect({
  selectedSection,
  setSelectedSection,
  setSelectedOutput,
  setActiveTab,
  data,
  pduiData,
  recentEmergency,
  statusSlot,
}) {
  const { t } = useTranslation();
  return (

    <div className={styles.pduiPortsContainer} >
      {pduiData.model && (
        <>
          {/* Desktop: spacer + PDUI centrado + botones a la derecha */}
          <div className={"d-none d-lg-flex align-items-center"} style={{ width: "100%", pointerEvents: "none" }}>
            <div className={"d-flex flex-row gap-2"} style={{ flex: "1 1 0", visibility: "hidden" }}>
              {isAdmin() && <GeneralSettings data={pduiData} t={t} />}
              {canOperate() && <ResetAll pduiId={pduiData.id} t={t} />}
              {pduiData.can_restart && isAdmin() && <RestartPDUI pduiId={pduiData.id} t={t} />}
            </div>
            <PduiStatus data={data} pduiData={pduiData} recentEmergency={recentEmergency} />
            <div className={"d-flex flex-row flex-wrap gap-2 justify-content-center"} style={{ flex: "1 1 0", pointerEvents: "auto" }}>
              {isAdmin() && <GeneralSettings data={pduiData} t={t} />}
              {canOperate() && <ResetAll pduiId={pduiData.id} t={t} />}
              {pduiData.can_restart && isAdmin() && <RestartPDUI pduiId={pduiData.id} t={t} />}
            </div>
          </div>

          {/* Mobile: PDUI centrado, luego botones en fila */}
          <div className={"d-lg-none d-flex flex-column align-items-center w-100"} style={{ pointerEvents: "auto" }}>
            <PduiStatus data={data} pduiData={pduiData} recentEmergency={recentEmergency} />
            <div className={"d-flex flex-wrap gap-2 justify-content-center mt-2"}>
              {isAdmin() && <GeneralSettings data={pduiData} t={t} />}
              {canOperate() && <ResetAll pduiId={pduiData.id} t={t} />}
              {pduiData.can_restart && isAdmin() && <RestartPDUI pduiId={pduiData.id} t={t} />}
            </div>
          </div>
        </>
      )}

      {/* Device status line under the PDUI image (e.g. uptime counter). Kept
          in normal flow, below the pulled-up image row, so it never overlaps
          the header at any width. */}
      {statusSlot}

      {
        Object.keys(pduiData).length > 0 && (
          <div className={styles.container}>
            <div
              className={`${styles.section} ${selectedSection === 1 && styles.selectedSection
                }`}
              onClick={() => {
                setSelectedSection(1);
                setSelectedOutput(-1);
                setActiveTab("details");
              }}
            >
              <div style={{ padding: "0 6px" }}>
                <FontAwesomeIcon
                  icon={faBolt}
                  size={"lg"}
                  color={selectedSection === 1 ? "#FFFFFF" : "#ED8B00"}
                />
              </div>
              <div>{t('detail.nav.consumption')}</div>
            </div>

            <div
              className={`${styles.section} ${selectedSection === 2 && styles.selectedSection
                }`}
              onClick={() => {
                setSelectedSection(2);
                setSelectedOutput(-1);
                setActiveTab("details");
              }}
            >
              <div style={{ padding: "0 6px" }}>
                <FontAwesomeIcon
                  icon={faBell}
                  size={"lg"}
                  color={selectedSection === 2 ? "#FFFFFF" : "#ED8B00"}
                />
              </div>
              <div>{t('detail.nav.alerts')}</div>
            </div>

            <div
              className={`${styles.section} ${selectedSection === 3 && styles.selectedSection
                }`}
              onClick={() => {
                setSelectedSection(3);
                setSelectedOutput(-1);
                setActiveTab("details");
              }}
            >
              <div style={{ padding: "0 6px" }}>
                <FontAwesomeIcon
                  icon={faTemperatureHalf}
                  size={"lg"}
                  color={selectedSection === 3 ? "#FFFFFF" : "#ED8B00"}
                />
              </div>
              <div>{t('detail.nav.temperature')}</div>
            </div>

            <div
              className={`${styles.section} ${selectedSection === 4 && styles.selectedSection
                }`}
              onClick={() => {
                setSelectedSection(4);
                setSelectedOutput(-1);
                setActiveTab("details");
              }}
            >
              <div style={{ padding: "0 6px" }}>
                <FontAwesomeIcon
                  icon={faFileLines}
                  size={"lg"}
                  color={selectedSection === 4 ? "#FFFFFF" : "#ED8B00"}
                />
              </div>
              <div>{t('detail.nav.logs')}</div>
            </div>

            {isAdmin() && (
            <div
              className={`${styles.section} ${selectedSection === 5 && styles.selectedSection
                }`}
              onClick={() => {
                setSelectedSection(5);
                setSelectedOutput(-1);
                setActiveTab("details");
              }}
            >
              <div style={{ padding: "0 6px" }}>
                <FontAwesomeIcon
                  icon={faNetworkWired}
                  size={"lg"}
                  color={selectedSection === 5 ? "#FFFFFF" : "#ED8B00"}
                />
              </div>
              <div>{t('detail.nav.network')}</div>
            </div>
            )}

            {isAdmin() && (
            <div
              className={`${styles.section} ${selectedSection === 6 && styles.selectedSection
                }`}
              onClick={() => {
                setSelectedSection(6);
                setSelectedOutput(-1);
                setActiveTab("details");
              }}
            >
              <div style={{ padding: "0 6px" }}>
                <FontAwesomeIcon
                  icon={faUpload}
                  size={"lg"}
                  color={selectedSection === 6 ? "#FFFFFF" : "#ED8B00"}
                />
              </div>
              <div>{t('detail.nav.firmware')}</div>
            </div>
            )}

            <div
              className={`${styles.section} ${selectedSection === 7 && styles.selectedSection
                }`}
              onClick={() => {
                setSelectedSection(7);
                setSelectedOutput(-1);
                setActiveTab("details");
              }}
            >
              <div style={{ padding: "0 6px" }}>
                <FontAwesomeIcon
                  icon={faClockRotateLeft}
                  size={"lg"}
                  color={selectedSection === 7 ? "#FFFFFF" : "#ED8B00"}
                />
              </div>
              <div>{t('detail.nav.history')}</div>
            </div>

            <div
              className={`${styles.section} ${selectedSection === 8 && styles.selectedSection
                }`}
              onClick={() => {
                setSelectedSection(8);
                setSelectedOutput(-1);
                setActiveTab("details");
              }}
            >
              <div style={{ padding: "0 6px" }}>
                <FontAwesomeIcon
                  icon={faCarBattery}
                  size={"lg"}
                  color={selectedSection === 8 ? "#FFFFFF" : "#ED8B00"}
                />
              </div>
              <div>{t('detail.nav.battery')}</div>
            </div>

            {isAdmin() && (
              <div
                className={`${styles.section} ${selectedSection === 9 && styles.selectedSection
                  }`}
                onClick={() => {
                  setSelectedSection(9);
                  setSelectedOutput(-1);
                  setActiveTab("details");
                }}
              >
                <div style={{ padding: "0 6px" }}>
                  <FontAwesomeIcon
                    icon={faSliders}
                    size={"lg"}
                    color={selectedSection === 9 ? "#FFFFFF" : "#ED8B00"}
                  />
                </div>
                <div>{t('detail.nav.params')}</div>
              </div>
            )}
          </div>
        )
      }
    </div >

  );
}
